import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import Card from "../components/Card";
import ProductModal from "../components/ProductModal";
import AntiqueCategoryBadge from "../components/AntiqueCategoryBadge";
import { apiFetch } from "../api";
import { toast } from "react-hot-toast";
import { Spinner } from "react-bootstrap";
import "./CategoryProducts.css";

const CategoryProducts = () => {
  // State and hooks
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  // Get category filter from URL
  const categoryFilter = searchParams.get('category');

  // State variables
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  // Fetch products on category change
  useEffect(() => {
    if (categoryFilter) {
      fetchCategoryProducts();
    } else {
      navigate('/products');
    }
  }, [categoryFilter]);

  // Fetch products and filter by category
  const fetchCategoryProducts = async () => {
    setLoading(true);
    try {
      const data = await apiFetch("/api/products/all");
      if (data.success && data.data) {
        const filtered = data.data.filter(
          product => product.category && product.category.name === categoryFilter
        );
        setAllProducts(filtered);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      toast.error("Failed to load products");
    }
    setLoading(false);
  };

  // Handle product click to open modal
  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  return (
    <div className="category-products-page">
      <button className="back-button" onClick={() => navigate('/products')}>
        <FaArrowLeft /> Back to All Categories
      </button>
      
      <div className="category-header">
        <AntiqueCategoryBadge title={categoryFilter || 'Products'} />
        <p className="category-count">{allProducts.length} Products</p>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" style={{ color: "#82287A", width: '3rem', height: '3rem' }} />
          <p className="mt-3">Loading products...</p>
        </div>
      ) : allProducts.length === 0 ? (
        <div className="text-center py-5">
          <h3 style={{ color: '#666' }}>No products found in this category</h3>
        </div>
      ) : (
        <div className="category-grid-view">
          {allProducts.map((product, index) => (
            <Card
              key={`${product._id}-${index}`}
              post={product}
              onClick={() => handleProductClick(product)}
            />
          ))}
        </div>
      )}

      {selectedProduct && (
        <ProductModal
          post={selectedProduct}
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  );
};

export default CategoryProducts;
